import * as React from 'react';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {URL} from '../../Config/appConfig';
import {CoverNote, Option} from '../../Config/dataModel';
import util from '../../Util/util';
import '../../style/closeButton.css';

const closeIcon = require('../../resource/img/close-default.svg');

interface CloseButtonProps {
    type?: string,
    goBack?: boolean,
    searchResult?: CoverNote[],
    identity?: Option,
    identityNo?: string,
    checksum?: string,
    clickClose?: (e: React.MouseEvent<HTMLElement>) => void
}

class CloseButton extends React.Component <RouteComponentProps & CloseButtonProps, {}> {
    public constructor(props: CloseButtonProps) {
        super(props);
        this.clickClose = this.clickClose.bind(this);
    }

    public clickClose(event: React.MouseEvent<HTMLElement>) {
        event.preventDefault();
        if (this.props.clickClose) this.props.clickClose(event);
        else {
            event.preventDefault();
            if (this.props.searchResult) {
                this.props.history.replace({
                    pathname: URL.SEARCH,
                    state: {
                        searchResult: this.props.searchResult,
                        identity: this.props.identity,
                        identityNo: this.props.identityNo,
                        checksum: this.props.checksum
                    }
                });
            }
            else {
                this.props.goBack ?
                    this.props.history.goBack() :
                    this.props.history.push(util.getDest(this.props.type || this.props.history.location.pathname.split('/')[2]));
            }
        }
    }

    public render() {
        return (
            <button className="cmBoldText closeButton" onClick={this.clickClose}>
                <div className="closeButtonContainer">
                    <img src={closeIcon}/>
                    <div className="closeButtonTitle">Close</div>
                </div>
            </button>
        );
    }
}

export default withRouter(CloseButton);



// WEBPACK FOOTER //
// ./src/Components/Custom/CloseButton.tsx